import Helper from "./Helper";

class Popup {
  constructor(config = {}) {
    const { buttons, closebtn, backdrops } = config;
    this.buttons = document.querySelectorAll(buttons);
    this.buttonsArray = Array.prototype.slice.call(this.buttons);
    this.closebtn = document.querySelectorAll(closebtn);
    this.closebtnArray = Array.prototype.slice.call(this.closebtn);
    this.backdrops = document.querySelectorAll(backdrops);
    this.backdropsArray = Array.prototype.slice.call(this.backdrops);

    if(this.backdrops.length !== 0){
      this.bindEvents();
    }
  }
  bindEvents() {
    this.buttonsArray.forEach((item)=>{
        item.addEventListener('click', (e) => {
          this.openPopup();
        });
      });

      this.backdropsArray.forEach((item)=>{
        item.addEventListener('click', (e) => {
          this.closePopup(item);
        });
      });

      this.closebtnArray.forEach((item)=>{
        item.addEventListener('click', (e) => {
          this.closePopup(item);
        });
      });
    }

    openPopup(item){
      const parent = Helper.getClosest(event.target, '.scroll-image__item');
      const popUpinParent = parent.querySelector('.popup');
      Helper.loadImagesInContainer('.scroll-image__item .popup');
      Helper.addClass(popUpinParent, 'is-visible');
      Helper.addClass(document.querySelector('body'), 'notes-open');
      setTimeout(() => {
        Helper.addClass(popUpinParent, 'fade-in');
      }, 300);
    }

    closePopup(item){
      const currentPopup = item.closest('.popup');
      Helper.removeClass(currentPopup, 'fade-in');
      Helper.removeClass(document.querySelector('body'), 'notes-open');
      setTimeout(() => {
        Helper.removeClass(currentPopup, 'is-visible');
      }, 300);
    }


}


export default Popup;
